import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { ReactNode } from 'react';

export default function WizardModal({
  children,
  onClose,
  isOpen,
}: {
  children: ReactNode;
  onClose: () => void;
  isOpen: boolean;
}) {
  return (
    <Modal
      isCentered
      onClose={onClose}
      isOpen={isOpen}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay backgroundColor="whiteAlpha.800" />
      <ModalContent
        padding={0}
        height="90vh"
        width="90vw"
        maxWidth="none"
        backgroundColor="gray.50"
      >
        {children}
      </ModalContent>
    </Modal>
  );
}
